export default __webpack_public_path__ + "static/media/bd-sim.dea0978b.jpg";